import { render, staticRenderFns } from "./goodsItem.vue?vue&type=template&id=46ae36f3&scoped=true"
import script from "./goodsItem.vue?vue&type=script&lang=js"
export * from "./goodsItem.vue?vue&type=script&lang=js"
import style0 from "./goodsItem.vue?vue&type=style&index=0&id=46ae36f3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ae36f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ae36f3')) {
      api.createRecord('46ae36f3', component.options)
    } else {
      api.reload('46ae36f3', component.options)
    }
    module.hot.accept("./goodsItem.vue?vue&type=template&id=46ae36f3&scoped=true", function () {
      api.rerender('46ae36f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformActivity/components/goodsItem.vue"
export default component.exports